import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Divider, Grid } from '@mui/material';

const FAQs = () => {
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={11} lg={12} xl={12} className="info-faqs-grid">
        <Typography className="info-faqs-heading">INFO</Typography>
      </Grid>
        <Grid item xs={12} sm={12} md={11} lg={12} xl={12} className="info-faqs-grid">
          <Box className='info-faqs-container'>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>What are the steps of an IDO?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography variant='caption'>
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>What is First Come First Serve (FCFS) sale? And who can participate in it?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography variant='caption' >
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>Do I need to unstake/restake for each IDO?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography>
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>Can I unstake after each IDO?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography variant='caption'>
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>What are the steps of an IDO?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography variant='caption'>
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>What is First Come First Serve (FCFS) sale? And who can participate in it?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography variant='caption' >
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>Do I need to unstake/restake for each IDO?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography>
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>Can I unstake after each IDO?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography variant='caption'>
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>What are the steps of an IDO?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography variant='caption'>
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>What is First Come First Serve (FCFS) sale? And who can participate in it?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography variant='caption' >
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>Do I need to unstake/restake for each IDO?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography>
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className="info-faqs-AccordionSummary"
          expandIcon={<ExpandMoreIcon sx={{ color:'#2f6df6' }}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='caption'>Can I unstake after each IDO?</Typography>
        </AccordionSummary>
        <AccordionDetails className='faq-detail-bar'>
          <Typography variant='caption'>
          The initial discovery was made by Twitter user DniweTamp, who posted two images showing lines of text purportedly from the game's executable. One image references a phrase "Superior Spider-Man", which can be applied to either Peter Parker or Miles Morales.
          </Typography>
        </AccordionDetails>
      </Accordion>
      </Box>
        </Grid>
    </Grid>
  );
};

export default FAQs;